import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { loadFontIcons } from 'components/FontIcon'
import store from 'utils/store'
import { PersistGate } from 'redux-persist/integration/react'
import persistStore from 'redux-persist/es/persistStore'
import { Spinner } from 'reactstrap'
import AppRoutes from './routes/index'
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom'
import { Spin } from 'antd'
import FloatingChat from 'MentalHealth/components/FloatingChat/FloatingChat'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { messaging } from "utils/firebase";
import { isSupported, onMessage } from "firebase/messaging";
import TranscriptionManager from 'MentalHealth/components/TranscriptionManager/TranscriptionManager'

function App() {

  const persistor = persistStore(store)
  const navigate = useNavigate(); // React Router v6 hook to navigate programmatically

  useEffect(() => {
    async function requestNotificationPermission() {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          console.log('Notification permission granted.');
        } else {
          console.log('Notification permission denied.');
        }
      } catch (error) {
        console.error('Error requesting notification permission:', error);
      }
    }

    requestNotificationPermission();
  }, []);

  useEffect(() => {
    async function setupMessaging() {
      if (await isSupported()) {
        onMessage(messaging, (payload) => {
          if (payload?.data) {
            const { data } = payload?.data
            console.log(payload?.data)

            createNotification(payload)
          }
        });
      }
    }

    setupMessaging();
  }, [])

  const createNotification = (NotificationObj) => {

    const { data, notification } = NotificationObj

    let title = 'Your Doctors Online'
    let body;

    // show notification olny when data and body only and do not move to any path
    if (!data?.messageType) {
      if (data?.ReminderType === "new_message" || data?.messageType === 'new_message') {
        const path = '/active-chats'

        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.doctorName || data?.name} Send you a New Message`
        }
        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })

      }
      if (data?.ReminderType === 'videoCall' || data?.messageType === 'videoCall') {

        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.name} Start a video Call please join`
        }

        const path = '/active-chats'

        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })
      }
      if (data?.ReminderType === 'audioCall' || data?.messageType === 'audioCall') {
        const path = '/active-chats'
        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.name} Start a audio call please join`
        }

        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })
      }
      if (data?.ReminderType === 'join_chat' || data?.messageType === 'join_chat') {

        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.doctorName || data?.name} start a consult please join chat`
        }

        const path = '/active-chats'
        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })
      }

      if (data?.ReminderType === 'appointment_reminder' || data?.messageType === 'appointment_reminder') {


        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.doctorName || data?.name} You have a appointment reminder`
        }

        const path = '/active-chats'
        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })

      }
      if (data?.ReminderType === 'appointment_scheduled' || data?.messageType === 'appointment_scheduled') {


        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.doctorName || data?.name} You have a new appointment`
        }

        const path = '/calendar'
        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })

      }

      if (data?.ReminderType === "close_chat" || data?.messageType === "close_chat") {

        if (notification) {
          body = notification?.body
          title = notification?.title
        } else {
          body = `${data?.doctorName} Close the chat`
        }

        const path = '/dashboard'

        NotificationManager.success(body, title, 5000, () => {
          handleNotificationClick(path);
        })
      }

      if (data?.ReminderType === 'screenShareWarning') {
        body = data?.message || 'Screen sharing is not capturing patient audio. Please make the Google Meet tab with "Share tab audio" enabled.'
        title = '⚠️ Screen Sharing Issue'

        NotificationManager.warning(body, title, 10000)

        // Also show a browser notification so the doctor sees it even if focused elsewhere
        if (Notification.permission === 'granted') {
          new Notification(title, {
            body,
            icon: 'https://cdn-clife.nitrocdn.com/ftCvgIygQEyRyIWBdgWdsCPtIQtBhwFo/assets/images/optimized/rev-68e9ff7/yourdoctors.online/wp-content/uploads/2021/09/logo_orange.svg',
          })
        }
      }

    }

  };


  const handleNotificationClick = (path, isDelegate, id) => {

    // Navigate to the given path
    navigate(path); // Use navigate to go to the given route

  };

  useEffect(() => {

    loadFontIcons()
  }, [])

  const location = useLocation()
  return (
    <Provider store={store}>
      {/* This container will hold the notifications */}
      <NotificationContainer />
      <PersistGate persistor={persistor} loading={<Loader />}>
        <AppRoutes />
        {/* <FloatingChat showOnTop={false} /> */}
        {(location.pathname !== '/active-chats' && location.pathname !== '/') && (
          <FloatingChat showOnTop={true} />
        )}
        <TranscriptionManager />
      </PersistGate>
    </Provider>
  )
}

export default App
export const Loader = () => <Spin spinning fullscreen />
